export default {
  TRANSLATION_SERVICE_NUMBER: '+14157077108',
};
